export default __webpack_public_path__ + "static/media/singpass_logo_fullcolours-1.8b1f7541.png";